import { asAuthErrorMessage } from '../../helpers/errors'

export const runBusyAuthAction = async <T>({
  setBusy,
  setError,
  action,
  onErrorResult,
}: {
  setBusy: (value: boolean) => void
  setError: (value: string) => void
  action: () => Promise<T>
  onErrorResult: T
}): Promise<T> => {
  setBusy(true)
  setError('')
  try {
    return await action()
  } catch (error) {
    setError(asAuthErrorMessage(error))
    return onErrorResult
  } finally {
    setBusy(false)
  }
}
